import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '../ui/tooltip';

const TooltipOptions = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          className='w-54 mr-2'
          sideOffset={8}
          side='top'
          variant='zinc'
        >
          <div className='w-full m-2'>
            <div className='space-y-1'>
              <p className='text-sm'>{t('tooltip.options.help')}</p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipOptions;
